import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../providers/UserProvider';

function postTutorDb(name, paypal, price, classes, classYear)
{
    //const user = useContext(UserContext);//take email out of parameters
    //const {email} = user;
    console.log("POSTING");
    var myParams = {
      name: name,
      email: localStorage.getItem('email'),
      paypal: paypal,
      price: price,
      classes: classes,
      classYear: classYear
  }
    console.log(myParams);
  axios.post("https://auxilliabackend.herokuapp.com/tutorProfile",myParams)
  .then(function (response) {
    //window.location.reload(true);
    localStorage.setItem('classes', response.classList);
  })
  .catch(function (error) {
    console.log(error);
  });
}

class tutorProfileSetupPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = { 
          name: "",
          //email: ,
          paypal: "",
          price: "",
          classes: "",
          classYear: ""
         };
        this.submitter = this.submitter.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        
      }
      
      handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }
    
    
      submitter(e){
        console.log("submitting function");
        e.preventDefault();
        postTutorDb(this.state.name, this.state.paypal, this.state.price, this.state.classes, this.state.classYear);
        // postTutorDb(this.state.name,this.state.email,this.state.paypal, this.state.price, this.state.classes, this.state.classYear);
        console.log("Submit log in information");
        this.props.history.push({pathname: '/chats'});
      }
    
      render() {
        return (
          <div className="App">
            
        
            <body className = "App-body">
              <div class = "submitboxT">
                {/* <img src = "logo192.png" class = "logo"></img> */}
                <h1>Tutor Profile Information</h1>
                  <form id="loginForm" onSubmit = {this.submitter}>
                    {/* <p>Username</p> */}
                    <p>Name</p>
                    <input type = "text" name = "name" placeholder = "Name" onChange = {this.handleInputChange}></input>
                    {/* <p>Email: (youremail@emailaddress.com)</p>
                    <input type = "text" name="email" placeholder = "Enter Email" onChange = {this.handleInputChange}></input> */}
                    <p>Paypal</p>
                    <input type = "text" name = "paypal" placeholder = "Paypal Email" onChange = {this.handleInputChange}></input>
                    <p>Price (Only put the number, no dollar sign)</p>
                    <input type="text" name="price" placeholder = "Tutor Price" onChange={this.handleInputChange} />
                    <p>Classes (Comma Separated w/ One Space: CSCE 315, MATH 151)</p>
                    <input type="text" name="classes" placeholder = "Classes Tutored" onChange={this.handleInputChange}/>
                    <p>Class Year</p>
                    <input type="text" name="classYear" placeholder = "Class Year" onChange={this.handleInputChange}/>
                    <p>Submit</p>
                    <input type = "submit" name = "submit" value = "Submit" onChange = {this.handleInputChange}></input >
                  </form>

              </div>

            </body>
            </div>
          // <div>   
          //   <form id="loginForm" onSubmit={this.submitter} >
          //       <label style={{display:'block',padding:'2%'}}>
          //       Name:
          //       <input type="text" name="name" style={{width:'50%'}} onChange={this.handleInputChange} />
          //       </label>              
          //       <label style={{display:'block',padding:'2%'}}>
          //       Email:
          //       <input type="text" name="email" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>
          //       <label style={{display:'block',padding:'2%'}}>
          //       PayPal Email:   
          //       <input type="text" name="paypal" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>
          //       <label style={{display:'block',padding:'2%'}}>
          //       Price:
          //       <input type="text" name="price" style={{width:'50%'}} onChange={this.handleInputChange} />
          //       </label>              
          //       <label style={{display:'block',padding:'2%'}}>
          //       Classes(Input with commas separating: CSCE315, CSCE313):
          //       <input type="text" name="classes" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>
          //       <label style={{display:'block',padding:'2%'}}>
          //       Class Year:   
          //       <input type="text" name="classYear" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>

          //       <input type="submit" value="Submit" style={{display:'block',padding:'2%'}}/>
          //   </form>
        
          // </div>
        );
      }
}



export default tutorProfileSetupPage;